import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import RequiredInventories from './components/RequiredInventories';

const requiredInventories = (props,{ t }) => (
  <Container>
    <RequiredInventories {...props} />
  </Container>
);

requiredInventories.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(requiredInventories);
